import { AxiosError } from 'axios'

import { responseStatus } from '@app/constants/responseStatus'

import type { AxiosInstance, AxiosResponse } from 'axios'

const handleMultiStatusError = async (response: AxiosResponse): Promise<AxiosResponse> => {
  if (!!response.data && response.status === responseStatus.MULTI_STATUS) {
    throw new AxiosError(response.data.textError, undefined, undefined, undefined, response)
  }

  return response
}

const applyMultiStatusError = (api: AxiosInstance): void => {
  api.interceptors.response.use(handleMultiStatusError, async error => await Promise.reject(error))
}

export default applyMultiStatusError
